import React from "react";
import Grid from "@material-ui/core/Grid";
import { Typography } from "@material-ui/core";
import EqualizerIcon from "@material-ui/icons//Equalizer";
import commonStyles from "../../common/styles/Common.styles";

const MissingStatsContainer = () => {
	const commonClasses = commonStyles();

	return (
		<Grid
			container
			align="center"
			spacing={4}
			className={commonClasses.contentCentered}
		>
			<Grid item md={12}>
				<EqualizerIcon className={commonClasses.contentCenteredIcon} />
				<Typography variant="h3">Stats are empty</Typography>
				<Typography variant="body1">
					Enter plays to start collecting stats
				</Typography>
			</Grid>
		</Grid>
	);
};

export default MissingStatsContainer;
